import { type UseModalState } from "@src/lib/ui-react";

import { Dialog } from "../../../components/Dialog";
import { DialogFooter } from "../../../components/DialogFooter";
import { Text } from "../../../components/Text";

interface MapleIntegrationConfirmationDialogProps {
  modalState: UseModalState;
  isTurningOn: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function MapleIntegrationConfirmationDialog({
  modalState,
  isTurningOn,
  isLoading,
  onConfirm,
  onCancel,
}: MapleIntegrationConfirmationDialogProps) {
  const title = isTurningOn ? "Enable Maple integration?" : "Disable Maple integration?";

  const description = isTurningOn
    ? "Enabling the Maple integration will sync shifts with Maple for this workplace."
    : "Disabling the Maple integration will stop all shift syncing with Maple for this workplace. This may cause the integration to become out of sync.";

  return (
    <Dialog modalState={modalState} title={title} onClose={onCancel}>
      <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
        {description}
      </Text>
      <DialogFooter
        primaryAction={{
          label: isTurningOn ? "Enable" : "Disable",
          variant: isTurningOn ? "primary" : "danger",
          isLoading,
          disabled: isLoading,
          onClick: onConfirm,
        }}
        secondaryAction={{
          label: "Cancel",
          onClick: onCancel,
          disabled: isLoading,
        }}
      />
    </Dialog>
  );
}
